import React, { Component } from "react";
import { test_version, public_version, rolled_back, version_name, version_code } from "../../../resources/string/strings"
import { ReactComponent as IconLab } from "../../../resources/image/ic_lab.svg";
import { ReactComponent as IconPublicRelease } from "../../../resources/image/ic_public_release.svg";
import { ReactComponent as IconLeft } from "../../../resources/image/ic_left.svg";
import { Link } from "react-router-dom";

class Adapter extends Component {
  state = {
    deleteModalShow: false,
  };

  render() {
    const { item, categoryPictureUrl, categoryTitle } = this.props;

    return (
      <div style={{ marginBottom: 16 }} className="col-12 row mx-auto">

        <Link target="_blank" to={"/releases/detail?i=" + item.id}
          className="app-card col-12"
          style={{ textDecoration: "none" }}
        >

          <div>

            {item.publicRelease &&
              <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right", marginBottom: 10 }}>
                <IconPublicRelease
                  className="p-0"
                  width="25"
                  height="25"
                />

                <span className="mr-2"> {public_version}</span>
              </div>
            }

            {!item.publicRelease &&
              <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right", marginBottom: 10 }}>
                <IconLab
                  className="p-0"
                  width="25"
                  height="25"
                />

                <span className="mr-2"> {test_version}</span>
              </div>
            }


            <div style={{ textAlign: "right", marginTop: 4 }}>
              <div className="mr-2 " style={{ fontSize: 14, color: "black", textDecoration: "none" }}>
                <span style={{ fontSize: 12, color: "silver" }}>{version_name}: </span>{item.versionName}
              </div>

            </div>

            {item.versionCode !== undefined && item.versionCode !== null && item.versionCode !== "" &&
              <div style={{ color: "slateblue", fontSize: 12, textAlign: "right", marginTop: 5 }}>
                <span style={{ fontSize: 12, color: "silver" }}>{version_code}: </span> {item.versionCode}
              </div>
            }

            <div style={{ color: "black", fontSize: 13, textAlign: "right", marginTop: 8 }}>
              {item.dateJalali}
            </div>


            {item.rollback !== undefined && item.rollback &&
              <div className="mt-2" style={{ color: "red", fontSize: 11, textAlign: "right", fontWeight: "bold" }}>
                {rolled_back}
              </div>
            }

          </div>

          <IconLeft
            className="p-0"
            width="25"
            height="25"
            color="gray"
            style={{ float: "left", marginTop: 10 }} />

          <div
            style={{ float: "right", marginTop: 10}}>

            <img
              width="25"
              height="25"
              src={categoryPictureUrl}
              alt=""
            />

            <span style={{color: "gray", fontSize: 13, marginRight: 5 }}> {categoryTitle}</span>
           
          </div>
        </Link>

      </div>

    );
  }
}

export default Adapter;
